import { courseDetailState } from '../ap_course_details_routes';
export const COURSE_DETAIL_TEMPLATE = `<ap-course-details hide-actions="true"></ap-course-details>`;
const advisorPlanEditCompareCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@ap-advisor.plan.edit.compare': {
      template: `<ap-course-details hide-actions="false"></ap-course-details>`
    }
  }
};
const advisorPlanEditCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@ap-advisor.plan.edit': {
      template: `<ap-course-details hide-actions="false"></ap-course-details>`
    }
  }
};
const advisorPlanViewCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@ap-advisor.plan.view': {
      template: COURSE_DETAIL_TEMPLATE
    }
  }
};
const studentPlanProgressCourseDetailState = {
  ...courseDetailState,
  views: {
    'right-panel-popout@ap-advisor.student-plan-progress': {
      template: COURSE_DETAIL_TEMPLATE
    }
  }
};

export const ApAdvisorCourseDetailRoutes = {
  'ap-advisor.plan.view.course_details': { ...advisorPlanViewCourseDetailState },
  'ap-advisor.plan.view.default.course_details': { ...advisorPlanViewCourseDetailState },
  'ap-advisor.plan.view.coursegroup.course_details': { ...advisorPlanViewCourseDetailState },
  'ap-advisor.plan.edit.course_details': { ...advisorPlanEditCourseDetailState },
  'ap-advisor.plan.edit.default.course_details': { ...advisorPlanEditCourseDetailState },
  'ap-advisor.plan.edit.compare.course_details': { ...advisorPlanEditCompareCourseDetailState },
  'ap-advisor.plan.edit.coursegroup.course_details': { ...advisorPlanEditCourseDetailState },
  'ap-advisor.student-plan-progress.course_details': { ...studentPlanProgressCourseDetailState }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/routes/advisor_routes/ap_advisor_course_detail_routes.ts